import { render } from "./ImageCard.vue?vue&type=template&id=dae645a8"
import script from "./ImageCard.vue?vue&type=script&lang=js"
export * from "./ImageCard.vue?vue&type=script&lang=js"

import "./ImageCard.vue?vue&type=style&index=0&id=dae645a8&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__